/**
 * @fileoverview Shared helpers and constants for the Register page form controls.
 * @module pages/register/registerFormHelpers
 */

export const NO_OPTIONS_I18N_KEY = "pages.register.noOptionsFound";
export const MIN_PASSWORD_LENGTH = 6;
export const MAX_PASSWORD_LENGTH = 15;
export const REGISTER_SUCCESS_REDIRECT_MS = 1000;
export const HTTP_CONFLICT = 409;

export const TABLET_MIN_WIDTH_PX = 768;
export const TABLET_MAX_WIDTH_PX = 1023;
export const MEDIUM_MOBILE_MIN_WIDTH_PX = 481;
export const MEDIUM_MOBILE_MAX_WIDTH_PX = 767;
export const SMALL_MOBILE_MAX_WIDTH_PX = 481;

/** @param {{ isSelected: boolean, isFocused: boolean }} state */
export const getSelectOptionBackgroundColor = (state) => {
  if (state.isSelected) {
    return "#007bff";
  }
  if (state.isFocused) {
    return "#f8f9fa";
  }
  return "white";
};

/** Shared react-select option styling for Register dropdowns. */
export const createRegisterSelectOptionStyle = (baseStyles, state) => ({
  ...baseStyles,
  textAlign: "left",
  cursor: "pointer",
  backgroundColor: getSelectOptionBackgroundColor(state),
  color: state.isSelected ? "white" : "#333",
  "&:hover": {
    backgroundColor: state.isSelected ? "#007bff" : "#f8f9fa",
  },
});

/** Filters react-select options by nombre field. */
export const filterSelectOptionByNombre = (option, inputValue) => {
  if (!inputValue) {
    return true;
  }
  return option.data.nombre.toLowerCase().includes(inputValue.toLowerCase());
};

/** Filters react-select options by codigo field. */
export const filterSelectOptionByCodigo = (option, inputValue) => {
  if (!inputValue) {
    return true;
  }
  return option.data.codigo.toLowerCase().includes(inputValue.toLowerCase());
};

export const getSelectOptionNombre = (option) => option.nombre;
export const getSelectOptionId = (option) => option._id;
export const getSelectOptionCodigo = (option) => option.codigo;
export const hideSelectIndicatorSeparator = () => ({ display: "none" });

/** Responsive width for paired react-select controls on Register. */
export const getNotSingleSelectWidth = (
  isTablet,
  isMediumMobile,
  isSmallMobile,
) => {
  if (isTablet) {
    return "270px";
  }
  if (isMediumMobile || isSmallMobile) {
    return "142px";
  }
  return "320px";
};

/** Responsive width for full-width react-select controls on Register. */
export const getSingleSelectWidth = (isTablet, isMediumMobile, isSmallMobile) => {
  if (isTablet) {
    return "555px";
  }
  if (isMediumMobile || isSmallMobile) {
    return "300px";
  }
  return "656px";
};
